import React from 'react';

const Notification = ({
  color,
  w = '18',
  h = '21',
}: {
  color?: string;
  w?: string;
  h?: string;
}) => {
  const fillColor = color || '#2D264B';

  return (
    <svg
      width={w}
      height={h}
      viewBox='0 0 18 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.84998 0C4.45442 0 1.82724 2.97603 2.24841 6.34536L2.32776 6.98021C2.44388 7.90916 2.10455 8.83706 1.41654 9.47195C-0.00913656 10.7875 -0.405232 12.8815 0.441418 14.6269L0.544769 14.84C1.29092 16.3782 2.80598 17.3856 4.49728 17.4909L4.68556 17.8136C5.69835 19.5498 7.27636 20.5 8.93339 20.5C10.5904 20.5 12.1684 19.5498 13.1812 17.8136L13.3725 17.4858C14.7931 17.3735 16.0885 16.6013 16.8611 15.3873C18.0432 13.5299 17.7301 11.0932 16.1168 9.59496L16.0729 9.5542C15.3344 8.86833 14.9708 7.86912 15.0958 6.86901L15.1604 6.35208C15.582 2.97918 12.952 0 9.55289 0H7.84998ZM4.91917 16C4.92819 15.9998 4.93721 15.9998 4.94621 16H12.9206C12.9296 15.9998 12.9386 15.9998 12.9476 16H13.0123C14.0592 16 15.0335 15.4652 15.5956 14.582C16.3891 13.3352 16.1789 11.6997 15.0961 10.6941L15.0522 10.6533C13.9602 9.63919 13.4225 8.16174 13.6074 6.68296L13.672 6.16603C13.9817 3.68841 12.0498 1.5 9.55289 1.5H7.84998C5.35667 1.5 3.42757 3.68526 3.73682 6.15931L3.81618 6.79416C3.99234 8.20345 3.47755 9.61114 2.43379 10.5743C1.49404 11.4415 1.23294 12.8218 1.79102 13.9723L1.89438 14.1853C2.43275 15.2952 3.5579 16 4.79147 16H4.91917ZM8.93339 19C8.01226 19 7.02948 18.5377 6.27013 17.5H11.5967C10.8373 18.5377 9.85453 19 8.93339 19Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default Notification;
